
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
//Components
import { MenuItem, ListItemIcon, ListItemText, Divider, Menu } from '@mui/material';

//Icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import AddBoxIcon from '@mui/icons-material/AddBox';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import {
    dashboardPanelCreateEditOpenModal,
} from 'Redux/actions';

//Styles
import './index.scss';

const MenuDashboards = (props) => {
    const { dashboards, setDashboardSelected, changeDashboard } = props
    const dispatch = useDispatch()
    const { messages } = useIntl();

    //Local States
    const [anchorEl, setAnchorEl] = useState(null);

    return (
        <>
            <div onClick={(event) => setAnchorEl(event.currentTarget)} className='select_dashboard_icon'>
                <DashboardIcon />
                {anchorEl && <KeyboardArrowUpIcon fontSize="small" />}
                {!anchorEl && <KeyboardArrowDownIcon fontSize="small" />}
            </div>
            <Menu
                elevation={0}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                className="menu-dashboard"
                getcontentanchorel={null}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                {
                    dashboards.filter((item) => !item?.shared)?.map((item, index) => (
                        <MenuItem
                            onClick={(c) => {
                                setAnchorEl(null)
                                changeDashboard(item.id)
                                setDashboardSelected(item);

                            }}
                            key={index}>
                            <ListItemIcon>
                                <DashboardIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary={item.name} className="listMenuItem" />
                        </MenuItem>
                    ))
                }
                {
                
                    dashboards.filter((item) => item?.shared).length ?
                    <>
                        <Divider />
                        <div style={{ margin: '10px 10px 10px 0' }}>
                            <span style={{ fontSize: '0.875rem', paddingLeft: 45 }} className="MuiTypography-root MuiTypography-body1 MuiListItemText-primary css-10hburv-MuiTypography-root">
                                {messages['menu_actions_shared_with_me']}
                            </span>
                        </div>
                    </> : <></>
                }
                {
                    dashboards.filter((item) => item?.shared)?.map((item, index) => (
                        <MenuItem
                            onClick={(c) => {
                                setAnchorEl(null)
                                changeDashboard(item.id)
                                setDashboardSelected(item);

                            }}
                            key={index}>
                            <ListItemIcon>
                                <DashboardIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary={`${item.name}`} className="listMenuItem" />
                        </MenuItem>
                    ))
                }
                <Divider />
                <MenuItem
                    onClick={(c) => {
                        setAnchorEl(null)
                        dispatch(dashboardPanelCreateEditOpenModal(true))
                    }}
                    key={12}
                >
                    <ListItemIcon>
                        <AddBoxIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary={messages['dashboardPanel_title_new']} className="listMenuItem" />
                </MenuItem>
            </Menu>
        </>
    )
}

export default MenuDashboards